export const OPsNavigatorOneTime = {
    navigateToInvitationListingPage: (browserHistory) => {
        if (!browserHistory) return;
        browserHistory.push("/assessmentsonetime/#/assessment_listing");
    },
    navigateToAssessment: (browserHistory, State, invitationId, assessmentFormName, comapnyName, questionId) => {
        
        if (!browserHistory) return;
        let url = '';
        if (questionId !== '' && questionId !== undefined) {
            url = `/assessmentsonetime/scoring_test/${invitationId}/${State}?questionid=${questionId}&assessmentname=${assessmentFormName}&companyname=${comapnyName}`;
       }
        else {
            url = `/assessmentsonetime/scoring_test/${invitationId}/${State}?assessmentname=${assessmentFormName}&companyname=${comapnyName}`;
       }
        
        const params = { assessmentFormName: assessmentFormName, comapnyName: comapnyName, questionId: questionId };
        browserHistory.push(url, params);
    },
}

export const OPsNavigatorMonthly = {
    navigateToInvitationListingPage: (browserHistory) => {
        if (!browserHistory) return;
        browserHistory.push("/assessmentsmonthly/#/assessment_listing");
    },
    navigateToAssessment: (browserHistory, State, invitationId, assessmentFormName, comapnyName, questionId) => {
        
        if (!browserHistory) return;
        let url = '';
        if (questionId !== '' && questionId !== undefined) {
            url = `/assessmentsmonthly/scoring_test/${invitationId}/${State}?questionid=${questionId}&assessmentname=${assessmentFormName}&companyname=${comapnyName}`;
       }
        else {
            url = `/assessmentsmonthly/scoring_test/${invitationId}/${State}?assessmentname=${assessmentFormName}&companyname=${comapnyName}`;
       }
        
        const params = { assessmentFormName: assessmentFormName, comapnyName: comapnyName, questionId: questionId };
        browserHistory.push(url, params);
    },
}
